<div class="row p-2" *ngIf="!hideHeaders">
  <div class="col-md-12 card card-body">
    <div class="row">
      <div class="col-6 col-sm-3 col-md-2 order-1">
      </div>
      <div class="col-12 col-sm-6 col-md-8 text-center order-3 order-md-2">
        <h4 class="h4-responsive">{{article?.title}}</h4>
      </div>
      <div class="col-6 col-sm-3 col-md-2 text-right order-2 order-md-3">
        <input type="button" class="btn btn-secondary d-print-none" value="Print" (click)="print()" />
      </div>
    </div>
  </div>
</div>
<div [innerHTML]="ArticleContent"></div>
<div class="row p-2 d-print-none" *ngIf="!hideHeaders">
  <div class="col card card-body">
    <div class="row">
      <div class="col-6 col-sm-3 col-md-2 order-1">
      </div>
      <div class="col-12 col-sm-6 col-md-8 text-center order-3 order-md-2">
        <h4 class="h4-responsive">{{article?.title}}</h4>
      </div>
      <div class="col-6 col-sm-3 col-md-2 text-right order-2 order-md-3">
        <input [disabled]="disabled" type="button" class="btn btn-primary" value="Next" (click)="submit()" />
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/library-assets/article/article.component.html